export default __webpack_public_path__ + "word_scribbler.24beb3.svg";